import WidgetSimpleView from './WidgetSimpleView'

export default WidgetSimpleView
